module.exports = {
  title: '企业端',
  // API_URL 接口地址
  API: {
    PREFIX1: '/userPortal/',
    PREFIX2: '/merchantProductPortal/',
    PREFIX3: '/marketPortal/',
    PREFIX4: '/businessConfPortal/',
    PREFIX5: '/kexin-resource/',
    PREFIX6: '/tradePortal/',
    PREFIX7: '/callbackPortal/',
    PREFIX8: '/userInfo/',
    PREFIX9: '/outerPortal/',
    PREFIX10: '/kexin-dict/',
    PREFIX11: '/settlementPortal/'
  },

  /**
   * @type {boolean} true | false
   * @description Whether show the settings right-panel
   */
  showSettings: true,

  /**
   * @type {boolean} true | false
   * @description Whether need tagsView
   */
  tagsView: true,

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: true,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false,

  /**
   * @type {'en' | 'cn' | 'th'} 英语 | 中文 | 泰文
   * @description 无语言设置时的默认语言
   */
  defaultLocale: 'cn'
};